import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { TeamMemberForAccount } from "../account/account.type";
import { AccountService } from '../account/account.service';
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'tm-out-of-office-settings',
    templateUrl: 'out-of-office-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OutOfOfficeSettingsComponent implements OnInit{

    protected teamMember: TeamMemberForAccount;

    constructor(
        private route: ActivatedRoute,
        private translate: TranslateService,
        private snackBarService: SnackBarService,
        private accountService: AccountService
    ) {}

    ngOnInit() {
        this.teamMember = this.route.snapshot.data['teamMember'];
    }

    saveChanges () {
        try {
            this.accountService.update(this.teamMember).then(() => {
                this.snackBarService.success(this.translate.instant('saved'));
            });
        } catch (e) {
            this.snackBarService.error(this.translate.instant('error'));
        }
    }
}
